import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { VueEditor } from 'vue2-editor'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faArrowsAlt, faUserAlt, faFeatherAlt, 
  faComments, faFileAlt, faSignOutAlt, 
  faTimes, faArrowRight, faBorderStyle,
  faTv, faQuestion, faPlusSquare, faMinusSquare,
  faGripLines, faSignInAlt, faExclamationTriangle,
  faFlag, faLock, faPen, faUserCog,
  faDiceOne, faDiceTwo, faDiceThree, faDiceFour, faDiceFive, faDiceSix,
  faSun, faCloud, faUmbrella, faMeteor, faSnowflake,
  faChevronCircleUp, faChevronCircleDown, faChevronCircleLeft, faChevronCircleRight
} from '@fortawesome/free-solid-svg-icons'
import {
  faTwitter
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSelectImage from 'vue-select-image'
import 'vue-select-image/dist/vue-select-image.css'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import VueScrollTo from 'vue-scrollto'
import VueSocialSharing from 'vue-social-sharing'

Vue.config.productionTip = false

/* VueEditor */
Vue.component('vue-editor', VueEditor)

/* Bootstrap */
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

/* FontAwesome */
library.add(faArrowsAlt, faUserAlt, faFeatherAlt,
  faComments, faFileAlt, faSignOutAlt,
  faTimes, faArrowRight, faBorderStyle,
  faTv, faQuestion, faPlusSquare, faMinusSquare,
  faGripLines, faSignInAlt, faExclamationTriangle,
  faFlag, faLock, faPen, faUserCog,
  faDiceOne, faDiceTwo, faDiceThree, faDiceFour, faDiceFive, faDiceSix,
  faSun, faCloud, faUmbrella, faMeteor, faSnowflake,
  faChevronCircleUp, faChevronCircleDown, faChevronCircleLeft, faChevronCircleRight,
  faTwitter)
Vue.component('font-awesome-icon', FontAwesomeIcon)

/* VueSelectImage */
Vue.use(VueSelectImage)

/* VueSelect */
Vue.component('v-select', VueSelect)

/* VueScrollTo */
Vue.use(VueScrollTo)

/* VueSocialSharing */
Vue.use(VueSocialSharing)

new Vue({
  router,
  store,
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.$store.dispatch('setWindowSize', {
        width: window.innerWidth,
        height: window.innerHeight
      })
    }
  },
  render: h => h(App)
}).$mount('#app')
